module.exports = __webpack_public_path__ + "media/images/payment_methods/ideal-bc642320282bb5bb613029869628d45a.svg";